import { render } from "./quiz-success.svg?vue&type=template&id=3977cfc5"
const script = {}
script.render = render

export default script